import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import HotScroll from './components/HotScroll';
import TestimonialSection from './components/TestimonialSection';
import MilestonesBar from './components/MilestonesBar';
import ArticlesGrid from './components/ArticlesGrid';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <title>91黑料吃瓜网 - 最新吃瓜视频与独家黑料直击现场 | 网红博主塌房事件每日在线更新</title>
      <meta name="description" content="91黑料吃瓜网📣作为黑料吃瓜内容集散地，🎥提供最新吃瓜视频与深度黑料直击。🎉覆盖网络红人、主播博主塌房现场，每日在线更新独家爆料与热门吃瓜事件，是您追踪内幕的首选平台。" />
      <meta name="keywords" content="91黑料吃瓜网, 91吃瓜视频, 91吃瓜在线观看, 网红塌房, 黑料曝光, 91吃瓜网官网, 91每日吃瓜, 91吃瓜爆料, 独家黑料, 吃瓜事件" />
      <link rel="canonical" href="http://aywxtna.cn/" />
      <meta property="og:title" content="91黑料吃瓜网 - 最新吃瓜视频与独家黑料直击现场" />
      <meta property="og:description" content="91黑料吃瓜网📣作为黑料吃瓜内容集散地，🎥提供最新吃瓜视频与深度黑料直击。🎉覆盖网络红人、主播博主塌房现场，每日在线更新独家爆料与热门吃瓜事件。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://aywxtna.cn/" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="91黑料吃瓜网 - 最新吃瓜视频与独家黑料直击现场" />
      <meta name="twitter:description" content="91黑料吃瓜网📣作为黑料吃瓜内容集散地，🎥提供最新吃瓜视频与深度黑料直击。🎉覆盖网络红人、主播博主塌房现场，每日在线更新。" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "91黑料吃瓜网 - 首页",
        "url": "http://aywxtna.cn/",
        "description": "黑料吃瓜内容集散地，提供最新吃瓜视频与深度黑料直击",
        "isPartOf": {
          "@type": "WebSite",
          "name": "91黑料吃瓜网",
          "url": "http://aywxtna.cn/"
        }
      }) }} />

      <HeroSection />
      <MilestonesBar />
      <FeatureGrid />
      <HotScroll />
      <ArticlesGrid />
      <TestimonialSection />
      <NewsletterSection />
    </>
  );
}